import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
export default class SplitController {
  constructor() {
    _defineProperty(this, "startPostId", null);
    _defineProperty(this, "endPostNumber", null);
    this.reset();
  }
  start(postId, postNumber) {
    this.reset();
    this.startPostId = postId;
    app.__fof_split.splitting = true;
    app.__fof_split.splittingFrom = postNumber;
    m.redraw();
  }
  end(postNumber) {
    this.endPostNumber = postNumber;
    app.__fof_split.splitting = false;
  }
  reset() {
    this.startPostId = null;
    this.endPostNumber = null;
    app.__fof_split.splitting = false;
    app.__fof_split.splittingFrom = undefined;
  }
}